import axios from "axios";
import publicHeader from "@/services/public-header";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/v2`;
const main = "BytePro";
const sub = "LoanPayment";

class LoanPaymentService {
  getLoanPaymentsByLoanNumberAndSSN4(loanNumber, borrowerSSN4) {
    return axios
      .get(
        `${API_URL}/${main}/${sub}/LoanNumber/${loanNumber}/SSN4/${borrowerSSN4}`,
        {
          headers: publicHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new LoanPaymentService();
